import { COUNTRY_OPTIONS } from "../../../utils/constants/countryOptions";

export function getWaveOptions(props, countryCode) {
  const availableWaves = [];

  const keys = Object.keys(props.optionsTree);

  keys.forEach((k) => {

    if (
      props.optionsTree[k].countries.includes(countryCode) ||
      countryCode === "LAC"
    ) {
      availableWaves.push({
        code: props.optionsTree[k].code,
        label: props.optionsTree[k].label,
      });
    }
  });

  return availableWaves;
}

export function getQuestionOptions(props, country, waveCode) {
  const availableQuestions = [];
  const questions = props.optionsTree[waveCode].questions;
  const questionKeys = Object.keys(questions);

  questionKeys.forEach((k) => {
    if (
      ((questions[k]["nan_country"] &&
        !questions[k]["nan_country"].includes(country)) ||
        !questions[k]["nan_country"]) &&
      !questions[k].disabled
    ) {
      availableQuestions.push({
        code: questions[k].code,
        label: questions[k].label,
      });
    }
  });

  return availableQuestions;
}

export function getVariableOptions(props, ignoreVariables, waveCode) {
  const availableVariables = [
    {
      code: "GENERAL",
      label: "General",
    },
  ];

  const variableKeys = Object.keys(props.optionsTree[waveCode].variables);
  variableKeys.forEach((k) => {
    if (!ignoreVariables.includes(k)) {
      availableVariables.push({
        code: props.optionsTree[waveCode].variables[k].code,
        label: props.optionsTree[waveCode].variables[k].label,
      });
    }
  });

  return availableVariables;
}

export function getComparableCountryOptions(
  props,
  country,
  wave_code,
  question_code
) {
  const countryOptions = [];

  props.optionsTree[wave_code].countries.forEach((countryOption) => {
    const foundCountry = COUNTRY_OPTIONS.find((country) => {
      return country.code === countryOption;
    });

    if (foundCountry === undefined) return;

    if (foundCountry.code !== country) {
      const questions = props.optionsTree[wave_code].questions;
      const hasNanCountries =
        questions[question_code].hasOwnProperty("nan_country");

      if (
        !hasNanCountries ||
        !questions[question_code].nan_country.includes(countryOption)
      ) {
        countryOptions.push({
          code: countryOption,
          label: foundCountry.country_text,
        });
      }
    }
  });

  return countryOptions;
}

export function getCorrectCategoryNames(
  props,
  wave_code,
  question_code,
  oldCategories
) {
  const correctCategories = oldCategories.map((cat) => {
    if (parseInt(cat) < 0)
      return props.optionsTree[wave_code]["no_answers_values"][cat];
    return props.optionsTree[wave_code].questions[question_code].values[cat];
  });

  return correctCategories;
}

export function getCorrectVariableNames(
  props,
  wave_code,
  variable_code,
  oldVariables
) {
  const correctVariableNames = {};
  oldVariables.forEach((variable) => {
    correctVariableNames[variable] =
      props.optionsTree[wave_code].variables[variable_code].values[variable];
  });
  return correctVariableNames;
}
